import styled from 'styled-components';

export const Title = styled.h1`
  font-family: "Poppins", serif;
  font-size: 24px;
  color: ${props => props.theme.darkGrey};
  @media (max-width: 576px) {
    font-size: 20px;
  }
`;

export const SubTitle = styled.h2`
  font-family: "Poppins", serif;
  font-size: 22px;
  color: ${props => props.theme.darkGrey};
  font-weight: ${props => props.fontWeight ? props.fontWeight : 500};
`;

export const CardTitle = styled.h4`
  font-family: "Poppins", serif;
  font-size: 18px;
  color: ${props => props.theme.darkGrey};
`;

export const CardTitleSmall = styled.h4`
  font-family: "Poppins", serif;
  font-size: 16px;
  color: ${props => props.theme.darkGrey};
`;

export const ButtonText = styled.p`
  font-family: "Poppins", serif;
  font-size: 14px;
  color: ${props => props.theme.grey};
  font-weight: 600;
`;

export const ContentText = styled.p`
  font-family: "Open sans regular", serif;
  font-size: 15px;
  color: ${props => props.theme.darkGrey};
`;

export const ImportantText = styled.p`
  font-family: ${props => props.font ? props.font : "Open sans regular"}, serif;
  font-size: 16px;
  color: ${props => props.theme.darkGrey};
  font-weight: bold;
`;

export const CustomText = styled.div`
  font-family: ${props => props.font === 'poppins' ? "Poppins" : "Open sans regular"}, serif;
  font-size: ${props => !!props.fontSize ? props.fontSize : 14}px;
  color: ${props => !!props.color ? props.color : props.theme.formLabel};
  font-weight: ${props => props.fontWeight ? props.fontWeight : 'normal'};
`;